import * as React from "react";
import classNames from "classnames";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { StoreState } from "../../reducers/root-reducer";
import { WithStyles, Theme, createStyles, withStyles } from "@material-ui/core";
import { InjectedTranslateProps, translate } from "react-i18next";
import { conf } from "../../conf";
import Button from "@material-ui/core/Button";
import {
	deactivateTableLinkMode,
	updateTableLinkGroups,
	updateSingleOccupiedDay
} from "../../actions/store/app-actions";

import Typography from "@material-ui/core/Typography";
import {
	saveTableLinkGroups,
	saveTableLinkGroupsAndUpdateStore
} from "../../actions/occupied-day-actions";
import { Reservation } from "../../api/reservations";
import { ConnectedTiteledPaper } from "../layout/titeled-paper";
import { OccupiedDay } from "../../api/occupied-days";

interface State {}

export interface TableLinkInfoboxProps {
	rootClass?: string;
}

interface ConnectedTableLinkInfoboxProps extends WithStyles<typeof styles> {
	tempTableLinkGroups: string[][];
	tableLinkActiveGroup: number;
	tableLinkModeActive: boolean;
	tableLinkDeletionModeActive: boolean;
	deactivateTableLinkMode: (persist: boolean) => void;
	updateSingleOccupiedDay: (id: string, updateData: OccupiedDay) => void;
}

type Props = TableLinkInfoboxProps &
	ConnectedTableLinkInfoboxProps &
	InjectedTranslateProps;

interface ReservationWithSignature extends Reservation {
	[index: string]: any;
}

export class TableLinkInfobox extends React.Component<Props, State> {
	handleConfirmClick = async () => {
		saveTableLinkGroupsAndUpdateStore();
	};

	handleCancelClick = () => {
		this.props.deactivateTableLinkMode(false);
	};

	canRenderSaveButton = () => {
		const {
			tableLinkActiveGroup,
			tableLinkModeActive,
			tableLinkDeletionModeActive
		} = this.props;

		return (
			(tableLinkModeActive && tableLinkActiveGroup > -1) ||
			tableLinkDeletionModeActive
		);
	};

	renderMessages() {
		const {
			classes,
			tableLinkActiveGroup,
			tableLinkModeActive,
			tableLinkDeletionModeActive
		} = this.props;

		if (tableLinkModeActive && tableLinkActiveGroup === -1) {
			return (
				<Typography>
					Nicht verbundenen Tisch anklicken um neue Gruppe zu
					erstellen,
					<br />
					oder verbundenen Tisch anklicken um weitere Tische
					hinzuzufügen.
				</Typography>
			);
		} else if (tableLinkModeActive && tableLinkActiveGroup > -1) {
			return (
				<div className={classes.activeGroupInfoContainer}>
					<div className={classes.activeGroupInfoIconContainer}>
						<div
							className={classes.activeGroupInfoIcon}
							style={{
								backgroundColor:
									conf.linkGroupColors[tableLinkActiveGroup]
							}}
						/>
					</div>
					<div className={classes.activeGroupInfoContent}>
						<Typography>
							Gruppe aktiv!
							<br />
							Weitere Tische anklicken um sie der Gruppe
							zuzuweisen.
						</Typography>
					</div>
				</div>
			);
		} else if (tableLinkDeletionModeActive) {
			return (
				<Typography>
					Tische anklicken deren Verbindung aufgehoben werden soll.
				</Typography>
			);
		}

		return null;
	}

	render() {
		const {
			classes,
			tableLinkModeActive,
			tableLinkDeletionModeActive,
			rootClass
		} = this.props;

		return (tableLinkModeActive || tableLinkDeletionModeActive) ? (
			<div className={classes.root}>  
					<ConnectedTiteledPaper 
						title={(tableLinkModeActive) ? "Tische verbinden" : "Verbindungen aufheben"}
					>
						{this.renderMessages()}

						<div className={classes.buttongroup}>
							<Button
									color="secondary"
									onClick={this.handleCancelClick}
								>
									Abbrechen
							</Button>
							{(this.canRenderSaveButton()) ? (
								<Button
										color="secondary"
										onClick={this.handleConfirmClick}
									>
										Speichern
								</Button>
							) : null}
						</div>
					</ConnectedTiteledPaper> 
			</div>
		) : null;
	}
}

const mapStateToProps = (state: StoreState) => ({
	tempTableLinkGroups: state.tempTableLinkGroups,
	tableLinkActiveGroup: state.tableLinkActiveGroup,
	tableLinkModeActive: state.tableLinkModeActive,
	tableLinkDeletionModeActive: state.tableLinkDeletionModeActive
});
 
const mapDispatchToProps = (dispatch: Dispatch) => ({
	deactivateTableLinkMode: (persist: boolean) =>
		dispatch(deactivateTableLinkMode(persist)),
	updateSingleOccupiedDay: (id: string, updateData: OccupiedDay) =>
		dispatch(updateSingleOccupiedDay(id, updateData))
});

const styles = (theme: Theme) =>
	createStyles({
		root: {
			marginBottom: 25,
			userSelect: "text"
		},
		buttongroup: {
			marginTop: 10,
			textAlign: "left"
		},
		activeGroupInfoContainer: {
			display: "flex",
			justifyConten: "center",
			alignItems: "center"
		},
		activeGroupInfoIconContainer: {
			paddingRight: 15
		},
		activeGroupInfoIcon: {
			width: 32,
			height: 32,
			borderRadius: "100%",
			backgroundColor: "#C5C5C5"
		},
		activeGroupInfoContent: {
			paddingLeft: 15,
			borderLeft: "1px solid lightgray"
		}
	});

export const ConnectedTableLinkInfobox = translate("translations")(
	withStyles(styles)(
		connect(
			mapStateToProps,
			mapDispatchToProps
		)(TableLinkInfobox)
	)
);
